(() => {
    var AccountPagePluginApp = (() => {
        var injectBlockDesktop = (element) => {
            const newBlock = document.createElement('div');
            newBlock.innerHTML = `
                <a class="chContent-Body-Menu-Cart" href="https://www.vapedinnerlady.com/pages/save-cart">
                    <p>Saved Carts</p>
                    <span class="icon">
                        <svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21,20V8.414a1,1,0,0,0-.293-.707L16.293,3.293A1,1,0,0,0,15.586,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20A1,1,0,0,0,21,20ZM9,8h4a1,1,0,0,1,0,2H9A1,1,0,0,1,9,8Zm7,11H8V15a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Z"/></svg>
                    </span>
                </a>
            `;
            element.appendChild(newBlock);
        };

        var waitAndInjectDesktop = () => {
            const targetSelector = '.chContent-Body-Menu-Block';

            const existing = document.querySelector(targetSelector);
            if (existing) {
                injectBlockDesktop(existing);
                return;
            }

            const observer = new MutationObserver((mutations, obs) => {
                const target = document.querySelector(targetSelector);
                if (target) {
                    obs.disconnect();
                    injectBlockDesktop(target);
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        };

        var injectBlockMobile = (element) => {
            const newBlock = document.createElement('div');
            newBlock.innerHTML = `
                <a class="chContent-Body-Menu-Cart-Mobile" href="https://www.vapedinnerlady.com/pages/save-cart">
                    <span class="icon">
                        <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21,20V8.414a1,1,0,0,0-.293-.707L16.293,3.293A1,1,0,0,0,15.586,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20A1,1,0,0,0,21,20ZM9,8h4a1,1,0,0,1,0,2H9A1,1,0,0,1,9,8Zm7,11H8V15a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Z"/></svg>
                    </span>
                    <p>Saved Carts</p>
                </a>
            `;
            element.appendChild(newBlock);
        };

        var waitAndInjectMobile = () => {
            const targetSelector = '.chFlowMobileMenuScroller';

            const existing = document.querySelector(targetSelector);
            if (existing) {
                injectBlockMobile(existing);
                return;
            }

            const observer = new MutationObserver((mutations, obs) => {
                const target = document.querySelector(targetSelector);
                if (target) {
                    obs.disconnect();
                    injectBlockMobile(target);
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        };

        var initialize = () => {
            waitAndInjectDesktop();
            waitAndInjectMobile();
        };

        return {
            init: initialize
        };
    })();

    var USRedirectPluginApp = (() => {
        var injectBlock = (element) => {
            const newBlock = document.createElement('div');
            newBlock.innerHTML = `
                <div class="age-popup-us-notice">
                    <div class="title">
                        <span>VISITING FROM THE US?</span>
                    </div>
                    <div class="us-store-banner">
                        <div class="us-store-banner__header">
                            <span class="us-store-banner__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="31.214" height="31.214" viewBox="0 0 31.214 31.214">
                                    <g id="United-states_flag_icon_round" transform="translate(0 0.109)">
                                    <circle cx="15.5" cy="15.5" r="15.5" transform="translate(0 0.106)" fill="#f0f0f0"/>
                                    <g transform="translate(0.538 3.284)">
                                        <path d="M244.87,193.288h16.286a15.624,15.624,0,0,0-.538-4.071H244.87Z" transform="translate(-230.479 -181.074)" fill="#d80027"/>
                                        <path d="M244.87,59.723h13.995a15.689,15.689,0,0,0-3.6-4.071H244.87Z" transform="translate(-230.479 -55.652)" fill="#d80027"/>
                                        <path d="M106.359,459.741a15.54,15.54,0,0,0,9.715-3.393H96.644A15.54,15.54,0,0,0,106.359,459.741Z" transform="translate(-91.29 -431.919)" fill="#d80027"/>
                                        <path d="M10.572,326.853H37.2a15.514,15.514,0,0,0,1.753-4.071H8.819A15.514,15.514,0,0,0,10.572,326.853Z" transform="translate(-8.819 -306.496)" fill="#d80027"/>
                                    </g>
                                    <path d="M7.23,2.437H8.652L7.329,3.4l.505,1.555L6.511,3.992l-1.323.961L5.625,3.61A15.693,15.693,0,0,0,2.6,6.984h.456L2.211,7.6q-.2.328-.378.667l.4,1.238-.75-.545q-.28.593-.51,1.212l.443,1.364H3.054l-1.323.961.505,1.555L.913,13.085l-.792.576A15.758,15.758,0,0,0,0,15.607H15.607V0A15.533,15.533,0,0,0,7.23,2.437Zm.6,11.609-1.323-.961-1.323.961.505-1.555L4.371,11.53H6.006l.505-1.555.505,1.555H8.652l-1.323.961Zm-.505-6.1L7.834,9.5,6.511,8.539,5.188,9.5l.505-1.555L4.371,6.984H6.006l.505-1.555.505,1.555H8.652Zm6.1,6.1-1.323-.961-1.323.961.505-1.555L9.969,11.53H11.6l.505-1.555.505,1.555H14.25l-1.323.961Zm-.505-6.1L13.432,9.5l-1.323-.961L10.787,9.5l.505-1.555L9.969,6.984H11.6l.505-1.555.505,1.555H14.25Zm0-4.546.505,1.555-1.323-.961-1.323.961L11.292,3.4,9.969,2.437H11.6L12.109.882l.505,1.555H14.25Z" transform="translate(0 -0.109)" fill="#0052b4"/>
                                    </g>
                                </svg>
                            </span>
                            <div>
                                <p class="us-store-banner__title">We have a dedicated US store</p>
                                <p class="us-store-banner__subtitle">This site only delivers to the UK</p>
                            </div>
                        </div>
                        <div class="us-store-banner__store-row">
                            <div class="us-store-banner__store-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                            </div>
                            <div class="us-store-banner__store-info">
                                <p class="us-store-banner__store-label">US Store</p>
                                <p class="us-store-banner__store-name">dinnerladyvape.com</p>
                            </div>
                            <div class="us-store-banner__ships-to">
                                <span class="us-store-banner__ships-dot"></span>
                                <span class="us-store-banner__ships-text">Ships to you</span>
                            </div>
                        </div>

                        <a class="us-store-banner__cta" href="https://dinnerladyvape.com">
                            <span class="text">CLICK HERE FOR US PRODUCTS AND DELIVERY</span>
                            <span class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9.668" height="16.335" viewBox="0 0 9.668 16.335">
                                    <path id="Icon_akar-arrow-right" data-name="Icon akar-arrow-right" d="M25.546,13.546,19.5,7.5l6.046,6.046L19.5,19.593" transform="translate(-17.379 -5.379)" fill="none" stroke="#e990b5" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            `;
            element.appendChild(newBlock);
        };

        var waitAndInject = () => {
            const targetSelector = '.popup-age-verification .popup-text';

            const existing = document.querySelector(targetSelector);
            if (existing) {
                injectBlock(existing);
                return;
            }

            const observer = new MutationObserver((mutations, obs) => {
                const target = document.querySelector(targetSelector);
                if (target) {
                    obs.disconnect();
                    injectBlock(target);
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        };

        var initialize = () => {
            if (document.querySelector('#us-topbar') && document.querySelector('#us-topbar .us-topbar__close')) {
                document.querySelector('#us-topbar .us-topbar__close').addEventListener('click', () => {
                    document.querySelector('#us-topbar').classList.add('d-none');
                });
            }
            fetch('/browsing_context_suggestions.json')
                .then(res => res.json())
                .then(data => {
                    const countryCode = data.detected_values.country.handle;
                    console.log('countryCode', countryCode);

                    if (countryCode === 'US') {
                        waitAndInject();
                        if (document.querySelector('#us-topbar')) {
                            document.querySelector('#us-topbar').classList.remove('d-none');
                        }
                    }
                });
        };

        return {
            init: initialize
        };
    })();

    var App = (() => {
        var initialize = () => {
            AccountPagePluginApp.init();
            USRedirectPluginApp.init();
        };

        return {
            init: initialize
        };
    })();

    document.addEventListener('DOMContentLoaded', () => {
        App.init();
    });
})();